import { FormInput } from "@policoders/ds";

import { ICompanyFormProps, useCompanyForm } from "./company-form.hook";

export const CompanyForm = ({ data, onChange }: ICompanyFormProps) => {
  const { state, handleChange } = useCompanyForm({
    data,
    onChange,
  });

  return (
    <div>
      <div className="row">
        <div className="col-12 col-sm-12 col-lg-8">
          <FormInput
            type="text"
            label="Empresa"
            field="name"
            value={state.name}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <FormInput
            type="text"
            label="CNPJ/CPF"
            field="docto"
            value={state.docto}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <FormInput
            type="text"
            label="Telefone"
            field="telephone"
            value={state.telephone}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-5">
          <FormInput
            type="email"
            label="E-mail"
            field="email"
            value={state.email}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <FormInput
            type="text"
            label="Site"
            field="site"
            value={state.site}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-9 col-lg-9">
          <FormInput
            type="text"
            label="Endereço"
            field="address"
            value={state.address}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-3 col-lg-3">
          <FormInput
            type="text"
            label="Número"
            field="addressNumber"
            value={state.addressNumber}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-12 col-lg-4">
          <FormInput
            type="text"
            label="Bairro"
            field="neighborhood"
            value={state.neighborhood}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-12 col-lg-4">
          <FormInput
            type="text"
            label="Cidade"
            field="city"
            value={state.city}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-12 col-lg-4">
          <FormInput
            type="text"
            label="Estado"
            field="state"
            value={state.state}
            list="state-list"
            onChange={handleChange}
          />
          <datalist id="state-list">
            <option value="SP" />
            <option value="RJ" />
          </datalist>
        </div>
      </div>
    </div>
  );
};
